module.exports = __webpack_public_path__ + "img/alumni-rini.efa4140a.jpg";